import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthUser } from 'src/app/login/administrador/AuthUser';
import { professorLoginResponse } from 'src/app/login/models/entities/professor-login-response';
import { ChangePasswordModalComponent } from 'src/app/shared-components/change-password-modal/change-password-modal.component';
import { UserRole } from 'src/app/_models/userEnum';
import { AuthService } from 'src/app/_services/auth.service';


@Component({
  selector: 'app-doc-password',
  templateUrl: './doc-password.component.html',
  styleUrls: ['./doc-password.component.css']
})
export class DocPasswordComponent implements OnInit {

  constructor(private modalService:NgbModal,
              private authService : AuthService){}
    profUser;

  ngOnInit()
  {
    this.profUser= this.authService.getProf() as professorLoginResponse;
      const currentUser = this.authService.getUser() as AuthUser;
      if(currentUser.role===UserRole.Professor && this.profUser)
      {
        if(this.profUser.statusPassword)
        {
          let openModal = this.modalService.open(
            ChangePasswordModalComponent,{ animation: true ,keyboard:false,backdrop: false}
          );
          openModal.componentInstance.typeNumber=2;
    
          openModal.result
            .then((result) => {
              if (result) 
              {}
            })
            .catch((err) => {});
              }
      }
    }
}
